import { createContext } from "react";

import type { Impulse } from "~/tools/impulse";

import type { TimeRangeHistory } from "./time-range-history-utils";

export const TimeRangeHistoryContext = createContext<undefined | Impulse<TimeRangeHistory>>(undefined);
